import { Link } from "react-router-dom"
import QuestionBlock from "../../components/assets/QuestionBlock"
import WhiteButton from "../../components/buttons/WhiteButton"
import ArrowUpRight from "../../components/icons/ArrowUpRight"

export default function FAQ() {
    const questions = [
        {
            question: "C'est quoi Zoeil, en fait ?",
            answer: "Zoeil, c’est une agence créative qui mise sur le fun, l’audace et des solutions sur mesure pour des projets uniques."
        },
        {
            question: "Quels services proposez-vous ?",
            answer: "On fait tout ce qui touche à l’identité visuelle, les campagnes de com’, le graphisme et la stratégie digitale."
        },
        {
            question: "Vous travaillez avec qui ?",
            answer: "On bosse avec tout le monde : des auto-entrepreneurs aux grandes boîtes en passant par les PME et startups."
        },
        {
            question: "Comment ça se passe pour lancer un projet ?",
            answer: "Simple, on commence par discuter ensemble pour capter vos besoins et établir une stratégie qui vous ressemble."
        },
        {
            question: "C’est quoi vos délais pour un projet ?",
            answer: "Ça dépend du projet, mais en général, c'est entre 2 et 6 semaines. On vous donne un délai précis dès le début."
        },
        {
            question: "Vous faites du boulot à distance ?",
            answer: "Oui, on travaille aussi bien en local qu’à distance, tout se gère facilement avec les outils en ligne."
        },
        {
            question: "Côté tarifs, vous faites comment ?",
            answer: "On est tout sur mesure. On vous propose un devis adapté à vos besoins spécifiques, pas de forfaits figés."
        },
        {
            question: "Je peux faire des modifs après la livraison ?",
            answer: "Bien sûr, on prévoit des révisions pour que tout soit nickel et que vous soyez satisfait."
        }, {
            question: "Comment vous assurez que vos créations sont originales ?",
            answer: "On crée tout de A à Z pour chaque client, pas de copier-coller ni de modèles tout faits ici."
        },
        {
            question: "Comment vous contacter pour bosser ensemble ?",
            answer: "Vous pouvez nous joindre via le site, nos réseaux ou par mail. On est réactifs partout !"
        }
    ]
    return (
        <div className="w-full min-h-[1210px] bg-zoeil-blue flex justify-center items-center text-white px-8 py-32">
            <div className="max-w-[1650px] flex flex-col gap-[6.25rem]">
                <div className="flex flex-col items-center">
                    <h2 className="text-heading-2 font-bold text-center leading-[100%] mb-6">
                        Tu te poses des questions ?
                    </h2>
                    <h3 className="text-center font-bold text-large max-w-[635px]">
                        On a pas forcément la science infuse mais on a compilé ce qu’on savait déjà juste en dessous.
                    </h3>
                </div>
                <div className="flex w-full gap-[2.625rem] mobile:flex-col mobile:gap-[1.5rem]">
                    <div className="basis-1/2 flex flex-col gap-[1.5rem]">
                        {questions.filter((v, index) => index % 2 == 0).map(v =>
                            <div>
                                <QuestionBlock {...v} />
                            </div>
                        )}
                    </div>
                    <div className="basis-1/2 flex flex-col gap-[1.5rem]">
                        {questions.filter((v, index) => index % 2 == 1).map(v =>
                            <div>
                                <QuestionBlock {...v} />
                            </div>
                        )}
                    </div>
                </div>
                <div className="w-full flex items-center justify-center gap-[4.125rem] mobile:flex-col mobile:gap-[1.5rem]">
                    <div className="text-very-large text-white font-[600] mobile:text-heading-5">
                        Encore des questions ?
                    </div>
                    <div className="w-fit mobile:w-full">
                        <Link to={"/contact"}>
                            <WhiteButton className={"text-zoeil-blue"} icon={<ArrowUpRight />}>
                                Poser une question
                            </WhiteButton>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}